import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import { RoutesLink } from "../utility/RouteLinks";
import Login from "../pages/auth/Login";
import Dashboard from "../pages/Dashboard/Dashboard";
import Labor from "../pages/Labor/Labor";
import CreateLabor from "@/pages/Labor/CreateLabor";
import LaborDetail from "@/pages/Labor/LaborDetail";
import DeviceAttendance from "@/pages/Attendance/DeviceAttendance";
import BulkAttendance from "@/pages/Attendance/BulkAttendance";
import BulkAddLabor from "@/pages/Labor/BulkAddLabor";
import Wages from "@/pages/Wages/Wages";
import Sites from "@/pages/Sites/Sites";
import CreateSite from "@/pages/Sites/CreateSite";
import SiteDetail from "@/pages/Sites/SiteDetail";
import Shift from "@/pages/Shift/Shift";
import WageEmployees from "@/pages/Wages/Wageemployees";
import WagePayments from "@/pages/Wages/Wagepayments";
import WagePaymentHistory from "@/pages/Wages/Wagepaymenthistory";
import Department from "@/pages/Department/Department";
import Supervisor from "@/pages/Supervisor/Supervisor";
import CreateSupervisor from "@/pages/Supervisor/CreateSupervisor";
import SupervisorDetails from "@/pages/Supervisor/Supervisordetails";
import LabourReport from "@/pages/Reprots/LabourReport";
import AttendanceReport from "@/pages/Reprots/AttendanceReport";
import PaymentReport from "@/pages/Reprots/PaymentReport";
import WageReport from "@/pages/Reprots/WageReport";
import Layout from "@/components/layout/Layout";
import AttendanceDetail from "@/pages/Attendance/AttendanceDetail";

interface RouteConfig {
  path: string;
  element: React.ReactNode;
}

export default function CommonRoutes() {
  const location = useLocation();

  const publicRoutes: RouteConfig[] = [
    { path: RoutesLink.authRoutes.login, element: <Login /> },
    // { path: RoutesLink.authRoutes.forgot, element: <Forgot /> },
  ];

  const privateRoutes: RouteConfig[] = [
    { path: RoutesLink.dashboard, element: <Dashboard /> },
    { path: RoutesLink.labor, element: <Labor /> },
    { path: RoutesLink.deviceAttendance, element: <DeviceAttendance /> },
    { path: RoutesLink.bulkAttendance, element: <BulkAttendance /> },
    { path:`${RoutesLink.attendanceDetail}/:id`, element: <AttendanceDetail />},


    // labour
    { path: RoutesLink.createLabor, element: <CreateLabor /> },
    { path: `${RoutesLink.editLabor}/:id`, element: <CreateLabor /> },
    { path: `${RoutesLink.laborDetail}/:id`, element: <LaborDetail /> },
    { path: `${RoutesLink.bulkAddLabor}`, element: <BulkAddLabor /> },

    // ─── Site routes ──────────────────────────────────
    { path: RoutesLink.site, element: <Sites /> },
    { path: RoutesLink.createSite, element: <CreateSite /> },
    { path: `${RoutesLink.siteDetail}/:id`, element: <SiteDetail /> },
    { path: `${RoutesLink.editSite}/:id`, element: <CreateSite /> },

    // ─── Shift routes ──────────────────────────────────
    { path: RoutesLink.shift, element: <Shift /> },

    // ─── Wages ──────────────────────────────────────────
    { path: RoutesLink.wages, element: <Wages /> },
    { path: RoutesLink.wageEmployees, element: <WageEmployees /> },
    { path: RoutesLink.wagePayment, element: <WagePayments /> },
    { path: RoutesLink.wagePaymentHistory, element: <WagePaymentHistory /> },

    // ─── Department ────────────────────────────────────
    { path: RoutesLink.department, element: <Department /> },

    // ─── Supervisor ────────────────────────────────────
    { path: RoutesLink.supervisors, element: <Supervisor /> },
    { path: RoutesLink.createSupervisor, element: <CreateSupervisor /> },
    {
      path: `${RoutesLink.supervisorDetail}/:id`,
      element: <SupervisorDetails />,
    },

    {
      path: RoutesLink.reports,
      element: <Navigate to={RoutesLink.labourReport} replace />,
    },
    { path: RoutesLink.labourReport, element: <LabourReport /> },
    { path: RoutesLink.attendanceReport, element: <AttendanceReport /> },
    { path: RoutesLink.wageReport, element: <WageReport /> },
    { path: RoutesLink.paymentReport, element: <PaymentReport /> },
    // { path: RoutesLink.contractorReport, element: <ContractorReport /> },
  ];

  return (
    <Routes>
      {publicRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={<PublicRoute element={route.element} />}
        />
      ))}

      {/* PrivateRoute guards auth; Layout mounts ONCE and wraps every private page via Outlet */}
      <Route element={<PrivateRoute />}>
        <Route element={<Layout />}>
          {privateRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Route>
      </Route>

      <Route
        path="*"
        element={
          <Navigate
            to={{
              pathname: RoutesLink.authRoutes.login,
              search: location.search,
            }}
            replace
          />
        }
      />
    </Routes>
  );
}